import {Component} from 'panel';

import {setOptState} from '../opt';
import {deactivateTracking} from '../tracking';
import template from './index.jade';
import css from './index.styl?inline';

export class GdprBanner extends Component {
  get config() {
    return {
      template,
      css,
      useShadowDom: true,
      defaultState: {hidden: true},
      helpers: {
        onAccept: () => {
          setOptState(`in`, `tracking`);
          setOptState(`in`, `storage`);
          this.dismiss();
        },
        onDismiss: () => {
          setOptState(`out`, `tracking`);
          setOptState(`out`, `storage`);
          this.dismiss();
        },
      },
    };
  }

  show() {
    // deactivate tracking by default while banner is present; will be re-activated on opt-in
    deactivateTracking();
    this.update({hidden: false});
  }

  dismiss() {
    this.update({hidden: true});

    window.setTimeout(() => {
      this.parentNode.removeChild(this);
    }, 400); // remove after fadeout animation
  }
}

customElements.define(`mp-gdpr-banner`, GdprBanner);
